import React from 'react';
import { useSignupLogic } from './SignupLogic';
import BasicSignupSkin from './skins/BasicSignupSkin';
import { COMPONENT_TYPES } from '../../../constants';
import { SkinnableComponent, ComponentSkinProps } from '../../../types/component-skin';

// Define the Signup skinnable component metadata
export const SignupSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.SIGNUP,
  name: '회원가입',
  category: 'form',
  icon: '👤',
  options: [
    {
      type: 'text',
      label: '제목',
      key: 'title',
      default: '회원가입'
    },
    {
      type: 'checkbox',
      label: '제목 표시',
      key: 'showTitle',
      default: true
    },
    {
      type: 'color',
      label: '제목 색상',
      key: 'titleColor',
      default: '#333333'
    },
    {
      type: 'text',
      label: '제목 크기',
      key: 'titleSize',
      default: '24px'
    },
    {
      type: 'color',
      label: '폼 배경색',
      key: 'formBackgroundColor',
      default: '#ffffff'
    },
    {
      type: 'text',
      label: '폼 테두리 둥글기',
      key: 'formBorderRadius',
      default: '8px'
    },
    {
      type: 'color',
      label: '버튼 색상',
      key: 'buttonColor',
      default: '#007bff'
    },
    {
      type: 'color',
      label: '버튼 텍스트 색상',
      key: 'buttonTextColor',
      default: '#ffffff'
    },
    {
      type: 'color',
      label: '에러 색상',
      key: 'errorColor',
      default: '#dc3545'
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicSignupSkin as React.ComponentType<ComponentSkinProps>
  },
  supportsExternalSkins: true,
  useLogic: useSignupLogic,
  defaultProps: {
    title: '회원가입',
    showTitle: true,
    titleColor: '#333333',
    titleSize: '24px',
    formBackgroundColor: '#ffffff',
    formBorderRadius: '8px',
    buttonColor: '#007bff',
    buttonTextColor: '#ffffff',
    errorColor: '#dc3545',
    style: {},
    className: '',
    content: {},
    data: {},
    componentProps: {},
    pathVariables: {},
    varFields: {
      var01: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var02: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var03: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var04: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var05: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var06: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var07: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var08: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var09: { show: false, label: "", type: "input", options: [], required: false, content: "" },
      var10: { show: false, label: "", type: "input", options: [], required: false, content: "" }
    },
    basicFields: {
      userId: true,
      password: true,
      name: true,
      phone: true,
      email: true,
      birthday: true,
      address: true,
      referralCode: true
    }
  }
};